import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  center: [0, 0], 
  zoom: 2,
};

// Map position code
const MapSlice = createSlice({
  name: "map",
  initialState,
  reducers: {
    setCenter: (state, action) => {
      state.center = action.payload;
    },
    setZoom: (state, action) => {
      state.zoom = action.payload;
    },
  },
});

export const { setCenter, setZoom } = MapSlice.actions;
export default MapSlice.reducer;
